
class SelectDropdown extends HTMLElement {
  constructor() {
    super();

    this.header = this.querySelector(".select-dropdown__header");

    this.header.addEventListener("click", () => {
      this.toggle();
    })

    // Close dropdown when clicking outside
    document.addEventListener("click", (event) => {
      if (!this.contains(event.target)) {
        this.classList.remove("select-dropdown--open");
      }
    });
  }

  toggle() {
    this.classList.toggle("select-dropdown--open");
  }

  disconnectedCallback() {
    this.header.removeEventListener("click", () => {
      this.toggle();
    })
  }
}

customElements.define("select-dropdown", SelectDropdown);
